import axiosInstance from "./axiosInstance";

export interface ApiDocument {
  documentId: number;
  documentCode: string;
  documentName: string;
  screenNames: string[];
  acceptedFormats: string;
  acceptedFormatsList: string[];
  isMandatory: boolean;
  maxFileSizeKB: number;
  maxFileSizeMB: number;
  expireMaxLimit?: string;
  isActive: boolean;
}

export interface DocumentListResponse {
  items: ApiDocument[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface DocumentListQuery {
  searchText?: string | null;
  documentName?: string | null;
  documentCode?: string | null;
  isMandatory?: boolean | null;
  isActive?: boolean | null;
  isDeleted?: boolean | null;
  pageNo?: number;
  pageSize?: number;
}

export interface DocumentQuery {
  onlyActive?: boolean;
}

export interface CreateDocumentPayload {
  documentCode: string;
  documentName: string;
  screenNames: string[];
  acceptedFormats: string;
  expireMaxLimit?: string;
  isMandatory: boolean;
  isActive: boolean;
  maxFileSizeKB: number;
  description?: string;
  createdBy: number;
}

export interface UpdateDocumentPayload {
  documentId: number;
  documentCode: string;
  documentName: string;
  screenNames: string[];
  acceptedFormats: string;
  expireMaxLimit?: string;
  isMandatory: boolean;
  isActive: boolean;
  maxFileSizeKB: number;
  description?: string;
  updatedBy: number;
}

export interface ApiScreen {
  screenId: number;
  screenKey: string;
  screenName: string;
  isActive: boolean;
}

// export interface DocumentApiResponse {
//   documentId: number;
//   documentName: string;
//   modules: string;
//   documentCode: string;
//   isMandatory: boolean;
// }

export interface DocumentApiResponse {
  documentId: number;
  documentName: string;
  documentCode: string;
  modules: string;        // ✅ FIXED
  isMandatory: boolean;
  // optional (if backend sends them later)
  acceptedFormatsList?: string[];
  maxFileSizeKB?: number;
  isActive?: boolean;
  screenNames?: string[];
  maxFileSizeMB?: number
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getDocuments = async (
  params: DocumentListQuery
): Promise<DocumentListResponse> => {
  const res = await axiosInstance.get("/Documents/list", { 
    params,
    headers: getAuthHeader(),
   });
  return res.data;
};

export const createDocument = async (
  payload: CreateDocumentPayload
): Promise<void> => {
  await axiosInstance.post("/Documents", payload,{
    headers: getAuthHeader(),
  });
};

export const updateDocument = async (
  payload: UpdateDocumentPayload
): Promise<void> => {
  await axiosInstance.put("/Documents", payload);
};

export const getDocumentScreens = async (
  onlyActive = true
): Promise<ApiScreen[]> => {
  const res = await axiosInstance.get("/Documents/Screen/All", {
    params: { onlyActive },
    headers: getAuthHeader(),
  });
  return res.data;
};

export interface DocumentSummary {
  totalDocuments: number;
  activeDocuments: number;
  mandatoryDocuments: number;
  optionalDocuments: number;
}

export const getDocumentSummary = async (): Promise<DocumentSummary> => {
  const res = await axiosInstance.get("/Documents/summary",{
    headers: getAuthHeader(),
  });
  return res.data;
};


export const getScreenDocuments = async (
  screenKey: string
): Promise<DocumentApiResponse[] | null> => {
  try {
    const response = await axiosInstance.get(`/Documents/screen/${screenKey}`,{
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const fetchAgeRulesApi = async (
) => {
  try {
    const response = await axiosInstance.get(`/AgeRule`, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    return null;
  }
};
